import React from 'react';

interface PackageIncludedInfoProps {
    isPackageIncluded?: boolean;
}

export function PackageIncludedInfo({ isPackageIncluded }: PackageIncludedInfoProps) {
    if (!isPackageIncluded) {
        return null;
    }

    return (
        <div className="d-flex align-items-center flex-wrap pt-2">
            <h6 className="mb-0">Package included</h6>
            <p className="mb-0 ml-1">- This offer includes a package.</p>
        </div>
    );
}
